/**
 * @file model for calendar
 * @author tobias.frei@notch-interactive.com
 *
 * @module components/calendar/filter-model
 */

const instance = {};

// instance.calendar;
// instance.settings;
// instance.mainElement;
// instance.resizeWidth;

export default instance;
